import { IssueData, ZodIssueCode } from 'zod';
import { isObject } from 'utils/helpers';
import { doesExist, isString } from 'utils/tsHelpers';
import { DateRange } from '../../types';

/**
 * Util to validate date range.
 * Checks if the date range is a valid entry
 */
export const validateDateRangeValue = (
  {
    value,
  }: {
    value?: string | DateRange;
  },
  addIssue: (arg: IssueData) => void,
) => {
  if (doesExist(value)) {
    if (isString(value)) {
      addIssue({
        code: ZodIssueCode.custom,
        message: 'missing or invalid date range',
        path: ['value'],
      });
    } else if (isObject(value) && (!doesExist(value?.startDate) || !doesExist(value?.endDate))) {
      addIssue({
        code: ZodIssueCode.custom,
        message: 'invalid date range',
        path: ['value'],
      });
    }
  }
};
